import { environment } from '../../../../../../environments/environment';
import { Shipping } from '../../../../../core';

const user = JSON.parse(localStorage.getItem(environment.sessionAuth));
const currency = user ? user.user.currencyCode : '';
const textCurrency = `Precio /${currency}`;
export const RETIRO_TIENDA = 'retiroTienda';

export const storePickupShipping = {
  searchText: 'Buscar configuraciones de flete',
  addText: 'Agregar flete',
  iconAddText: 'add',
  columns: [
    {
      title: 'Descripción',
      name: 'description',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: Shipping) => element.description || ''
    },
    {
      title: 'Tipo de despacho',
      name: 'type',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: Shipping) => element.dispatchTypeName || ''
    },
    {
      title: 'Medida',
      name: 'measure',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: Shipping) => {
        if (element.rule !== 'PER_WEIGHT_RULE') {
          return 'Unidad';
        } else {
          return 'Peso';
        }
      }
    },
    {
      title: textCurrency,
      name: 'costs',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: Shipping) => {
        if (element.rule !== 'PER_WEIGHT_RULE') {
          return Number(element.costs[0].amount).toFixed(2);
        } else {
          return element.costs.map(item => item.amount).join('/');
        }
      }
    },
    {
      title: 'Productos',
      name: 'view',
      type: 'button',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: Shipping) => {
        return {
          data: element.id,
          icon: 'low_priority',
          tooltip: 'Ver más',
          class: 'recordColumn icon-table'
        };
      }
    },
    {
      title: 'Eliminar',
      name: 'delete',
      type: 'button',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: Shipping) => {
        return {
          data: element.id,
          icon: 'delete',
          tooltip: 'Eliminar',
          class: ' recordColumn icon-table'
        };
      }
    }
  ],
  show: 'No hay configuraciones de flete disponibles'
};
